
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.278.839v1.255a.628.628 0 01-.627.628h-2.463L7.05 15.278h1.835c.347 0 .628.281.628.628v1.255a.628.628 0 01-.628.628H1.35a.628.628 0 01-.627-.628v-1.255c0-.347.28-.628.627-.628h2.463L6.952 2.722H5.117a.628.628 0 01-.628-.628V.84c0-.347.282-.628.628-.628h7.534c.346 0 .627.281.627.628z","fill":"#282828"}})])
          )
        }
      }
    